import React, { useState, useEffect } from 'react';
import { getTemplateString } from 'common/helpers/string';
import { getTemplateToken } from 'common/helpers/tokensFormatter';
import { createIntl, createIntlCache, FormattedNumber } from 'react-intl';
import RangeSlider from 'components/RangeSlider/RangeSlider';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import {
  FormatMoney,
  hasFractionalPart,
  FormatMoneyWithoutDecimal,
  parseStringAmountToFloat,
} from 'common/helpers/numberHelper';
import TagManager from 'react-gtm-module';

import { formError, formProgression } from 'common/helpers/Gtm';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
  updateAmountslider: Function;
  UpdateNumberofMonth: Function;
  InstallmentAmountchanged: boolean;
  setisDisabled: Function;
  setFinalPaymentValue?: any;
  availableIncome?: any;
}

const Monthlyrate = ({
  PageData,
  Model,
  LayoutModel,
  updateAmountslider,
  UpdateNumberofMonth,
  InstallmentAmountchanged,
  setisDisabled,
  setFinalPaymentValue,
  availableIncome,
}: Props) => {
  const [instalmentValue, setinstalmentValue] = useState(
    Model?.SelectedInstalmentValue / 100,
  );
  const cache = createIntlCache();

  // TODO: Get current language
  const intl = createIntl(
    {
      locale: 'fr',
    },
    cache,
  );
  var valueinputRaw: any;
  const InstalmentValueErrorMessage = getTemplateString(
    PageData?.InstalmentValueErrorMessage,
  );
  const InstalmentValueFractionalPartErrorMessage = getTemplateString(
    PageData?.InstalmentValueFractionalPartErrorMessage,
  );

  const instalmentMaxToken = getTemplateToken(
    Model?.FormattedCurrencyinstalmentMax,
  );
  const instalmentMinToken = getTemplateToken(
    Model?.FormattedCurrencyInstalmentMin,
  );
  const OverTheDisposableIncomeNotice = getTemplateString(
    PageData?.OverTheDisposableIncomeNotice,
  );
  const incomeLimitToken = getTemplateToken(
    Model?.FormattedCurrencyDisposableIncomeLimit,
  );

  const [outRangeError, setoutRangeError] = useState(false);
  const [fractionError, setfractionError] = useState(false);
  const [isEditedValue, setIsEditedValue] = useState(false);
  const [overDisposableError, setOverDisposableError] = useState(false);
  const paymentOptions = Model.PaymentOptions;
  const debtbalanceRaw= Model?.DebtBalance > 0 ? Model.DebtBalance/100:0;
  let minvalue = Model?.InstalmentMinValue / 100;
  let maxvalue = Model?.InstalmentMaxValue / 100;
  const disableContinueBtnForFractionalValueError = () => {
    if (instalmentValue != maxvalue) {
      if (instalmentValue > Math.floor(instalmentValue)) {
        setfractionError(false);
        setisDisabled(false);
      } else {
        setfractionError(true);
        setisDisabled(true);
      }
    }
  };

  useEffect(() => {
    if (outRangeError === true) {
      var errorMessage = InstalmentValueErrorMessage ? InstalmentValueErrorMessage({
        Min: instalmentMinToken,
        Max: instalmentMaxToken,
      })
    : '';
      formError('UpdatePlanChangeAmount','InstallmentAmount','error_installment_value_outof_range');
    }
  }, [outRangeError]);

  useEffect(() => {
    if (fractionError === true) {
      var errorMessage = InstalmentValueFractionalPartErrorMessage
      ? InstalmentValueFractionalPartErrorMessage({
          Min: instalmentMinToken,
          Max: instalmentMaxToken,
        })
      : '';
      formError('UpdatePlanChangeAmount','InstallmentAmount','error_installment_value_with_fractional_part');
    }
  }, [fractionError]);
  const onUpdateSelectedInstalmentValue = (
    e: React.FormEvent<HTMLInputElement>,
  ): void => {
    let valueinput: number;
    let valueinputString: any = e.currentTarget.value;
    valueinputRaw = e.currentTarget.value;
    setOverDisposableError(false);
    if (
      valueinputString == null ||
      valueinputString == undefined ||
      isNullOrWhiteSpace(valueinputString)
    ) {
      valueinput = 0;
    } else {
      valueinput = valueinputString;
    }
    if (valueinput != 0) {
      let numericValue: any;
      var cleanUpRegex = /[^0-9\,\.]/g;
      var cleanUpSeparatorsRegex = /[\,\.]/g;
      valueinputString = valueinputString.replace(cleanUpRegex, '');

      if (valueinputString === '') {
        numericValue = 0;
      }

      var lastSeparatorPosition = Math.max(
        valueinputString.lastIndexOf(','),
        valueinputString.lastIndexOf('.'),
      );

      if (lastSeparatorPosition === -1) {
        numericValue = parseFloat(valueinputString);
      } else {
        var integer = valueinputString.substring(0, lastSeparatorPosition);
        integer = integer.replace(cleanUpSeparatorsRegex, '');
        var decimal = valueinputString.substring(
          lastSeparatorPosition + 1,
          valueinputString.length,
        );

        if (integer === '' && decimal === '') {
          numericValue = 0;
        }

        if (decimal.length > 2) {
          decimal = decimal.substring(0, 2);
        }
        if (decimal.length == 0 && lastSeparatorPosition > -1) {
          valueinput = valueinputString;
          setinstalmentValue(valueinput);
          setIsEditedValue(true);
          return;
        } else {
          numericValue = parseFloat(integer + '.' + decimal);
        }
      }
      if (numericValue === 0) {
        valueinput = 0;
      } else if (numericValue < minvalue) {
        valueinput = numericValue;
      } else if (numericValue > maxvalue) {
        valueinput = numericValue;
      } else if (numericValue != maxvalue && hasFractionalPart(numericValue)) {
        valueinput = numericValue;
      } else {
        valueinput = numericValue;
      }
    }
    if (valueinput >= minvalue && valueinput <= maxvalue) {
      setoutRangeError(false);
      setisDisabled(false);
    } else {
      setoutRangeError(true);
      setisDisabled(true);
    }
    if (valueinput > 0) {
      setinstalmentValue(valueinput);
    } else {
      setinstalmentValue(valueinput);
    }
    if (valueinput != maxvalue) {
      if (valueinput % 1 > 0) {
        setfractionError(true);
        setisDisabled(true);
      } else {
        console.log();
        setfractionError(false);
      }
    }
    else
    {
        setfractionError(false);
    }
    if (valueinput == 0) {
      valueinputRaw = '';
    }
    setIsEditedValue(true);
  };
  updateAmountslider(instalmentValue);

  const onButtonMinusClick = () => {
    if (instalmentValue <= minvalue) {
      setinstalmentValue(minvalue);
    } else {
      setinstalmentValue(Math.ceil(instalmentValue - 1));
    }
    setIsEditedValue(false);
    errormsg(false);
    setRangeError(-1);
  };
  const onButtonPlusClick = () => {
    if (instalmentValue >= maxvalue) {
      setinstalmentValue(maxvalue);
    } else {
      setinstalmentValue(Math.floor(instalmentValue + 1));
    }
    setIsEditedValue(false);
    errormsg(false);
    setRangeError(1);  
  };

  const setRangeError=(value : number)=>{
    let selctedValue = Math.floor(instalmentValue + value);
    if (selctedValue >= minvalue && selctedValue <= maxvalue) {
      setoutRangeError(false);
      setisDisabled(false);
    } else {
      setoutRangeError(true);
      setisDisabled(true);
    }
  }

  const errormsg = (value: boolean) => {
    setfractionError(value);
    setisDisabled(value);
    setoutRangeError(value);
  };
  useEffect(() => {
    setOverDisposableError(false);
    let formattedAvailableIncome = parseStringAmountToFloat(availableIncome);
    if(!isNullOrWhiteSpace(availableIncome))
    {
    if (formattedAvailableIncome >= 0) {
      if (instalmentValue > formattedAvailableIncome) {
        setOverDisposableError(true);
      }
    }
  }
}, [instalmentValue, availableIncome]);
  useEffect(() => {
    if (instalmentValue>0 && debtbalanceRaw>0) {
      UpdateNumberofMonth(Math.floor(debtbalanceRaw / instalmentValue))
      setFinalPaymentValue(Math.round((debtbalanceRaw % instalmentValue) * 100))
    }
}, [instalmentValue]);
useEffect(() => {
  if (overDisposableError) {
    var tagManagerArgs: any;
    tagManagerArgs = {
      dataLayer: {
        event: 'form_error',
        checkout_name: 'Payment Plan Update',
        error_message: 'Disposable income too low'
      }
    }
    TagManager.dataLayer(tagManagerArgs);
  }
}, [overDisposableError]);
  return (
    <div className="Monthlyrate">
      <div className="Monthlyrate-intro">
        <h3 className="Heading CreateRepaymentPlan-heading">
          {PageData?.CalculatorHeading}
        </h3>
        <p>{PageData?.CalculatorDescription}</p>
      </div>
      <div className="Grid">
        <div className="Grid-cell u-size1of5">
          <div className=" Monthlyrate-maxMin Monthlyrate-min">
            <label>{PageData?.CalculatorMinRateLabel}</label>
            <span
              dangerouslySetInnerHTML={{ __html: Model?.CalculatorMinRate }}
            />
          </div>
          <div
            className="Monthlyrate-minusButton Monthlyrate-plusMinusButton"
            onClick={onButtonMinusClick}
          >
            <a className="Button Button--circular-minus Button--circular slider-wrapper minus">
              <span></span>
            </a>
          </div>
        </div>
        <div className="Grid-cell u-size3of5 ">
          <div className="Monthlyrate-inputWrapper">
            <div className="Input Input-icon Input-icon--after Icon-pen--after u-textCenter">
              <input
                type="text"
                className="u-hidden"
                defaultValue={instalmentValue}
              />
              <input
                type="text"
                placeholder=""
                className="instructions"
                step="0.01"
                value={
                  !isEditedValue && instalmentValue != maxvalue
                    ? FormatMoneyWithoutDecimal(
                      instalmentValue,
                      Model?.FormattedCurrencySymbol,
                      LayoutModel?.IsCurrencyOnTheLeftSide,
                    )
                    : !isEditedValue && instalmentValue == maxvalue
                      ? FormatMoney(
                        instalmentValue,
                        Model?.FormattedCurrencySymbol,
                        LayoutModel?.IsCurrencyOnTheLeftSide,
                        LayoutModel?.DecimalSeparatorForNumberFormatter,
                      )
                      : valueinputRaw
                }
                disabled={instalmentValue == maxvalue ? true : false}
                onChange={onUpdateSelectedInstalmentValue}
                onBlur={(e)=>formProgression(e,'UpdatePlanChangeAmountForm','InstallmentAmount')}
              />

              <span className="Text--small">
                {PageData?.CalculatorAmountFieldHint}
              </span>
            </div>
          </div>
        </div>
        <div className="Grid-cell u-size1of5 ">
          <div className="Monthlyrate-maxMin Monthlyrate-max">
            <label>{PageData?.CalculatorMaxRateLabel}</label>
            <span
              dangerouslySetInnerHTML={{ __html: Model?.CalculatorMaxRate }}
            />
          </div>
          <div
            className="Monthlyrate-plusButton Monthlyrate-plusMinusButton"
            onClick={onButtonPlusClick}
          >
            <a className="Button Button--circular-plus Button--circular slider-wrapper plus">
              <span></span>
            </a>
          </div>
        </div>
      </div>

      {(outRangeError || fractionError) && (
        <div className="InstallmentAmount_ErrorBox">		
        <h2 className="HeaderText">
        {PageData?.InstallmentAmountErrorHeading}
        </h2>        
        {fractionError && (<p
            className="ParagraphText"
            dangerouslySetInnerHTML={{
              __html: InstalmentValueFractionalPartErrorMessage
                ? InstalmentValueFractionalPartErrorMessage({
                    Min: instalmentMinToken,
                    Max: instalmentMaxToken,
                  })
                : '',
            }}
        />)}

        {outRangeError && (
          <p
            className="ParagraphText"
            dangerouslySetInnerHTML={{
              __html: InstalmentValueErrorMessage
                ? InstalmentValueErrorMessage({
                    Min: instalmentMinToken,
                    Max: instalmentMaxToken,
                  })
                : '',
            }}
          />
        )}
        
        </div>
        )}
      <RangeSlider
        InstalmentValue={instalmentValue}
        InstalmentMinValue={Model?.InstalmentMinValue}
        InstalmentMaxValue={Model?.InstalmentMaxValue}
        setInstalmentValue={setinstalmentValue}
        errormsg={errormsg}
        setIsEditedValue={setIsEditedValue}
      />
      
      {overDisposableError && (
        <div className="Grid-cell u-size1of1 u-textCenter over-limit-message Monthlyrate-ValidationMessage">
          <strong>
            <>{PageData?.Notice}</>
          </strong>
          <div
            dangerouslySetInnerHTML={{
              __html:
                (OverTheDisposableIncomeNotice &&
                  OverTheDisposableIncomeNotice({
                    IncomeLimit: incomeLimitToken,
                  })) ||
                '',
            }}
          />
        </div>
      )}
      {InstallmentAmountchanged && (
        <div className="Grid-cell u-size1of1 u-textCenter text-danger">
          {Model?.PageDataBase?.SelectedInstallmentAmountNotChangedErrorMessage}
        </div>
      )}
    </div>
  );
};

export default Monthlyrate;
